import { employeeServiceApi } from "../../app/employeeServiceApi";
import { API_URL } from "../../constants/apiUrl";
import {
  GetDepartmentDetailsResponseType,
  GetDepartmentsParams,
  GetDepartmentsResponseType,
  GetQueryArgsType,
  PatchQueryArgsType,
} from "../../types";

export const departmentApi = employeeServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getDepartments: builder.query<
      GetDepartmentsResponseType,
      GetQueryArgsType<GetDepartmentsParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getDepartments,
        ...queryArgs,
      }),
      providesTags: ["GetDepartments"],
    }),
    getDepartmentDetails: builder.query<
      GetDepartmentDetailsResponseType,
      string
    >({
      query: (id) => ({
        url: `${API_URL.getDepartmentDetails}/${id}`,
      }),
      providesTags: (_, __, id) => [
        {
          type: "GetDepartmentDetails",
          id,
        },
      ],
    }),
    addDepartment: builder.mutation({
      query: (data) => ({
        url: API_URL.addDepartment,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetDepartments"];
        return [];
      },
    }),
    updateDepartment: builder.mutation<void, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${API_URL.updateDepartment}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetDepartments",
            {
              type: "GetDepartmentDetails",
              id,
            },
          ];

        return [];
      },
    }),
    updateDepartmentStatus: builder.mutation<void, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${API_URL.updateDepartmentStatus}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetDepartments",
            {
              type: "GetDepartmentDetails",
              id,
            },
          ];

        return [];
      },
    }),
  }),
});

export const {
  useGetDepartmentsQuery,
  useGetDepartmentDetailsQuery,
  useAddDepartmentMutation,
  useUpdateDepartmentMutation,
  useUpdateDepartmentStatusMutation,
} = departmentApi;
